<div class="page-container container user-management-container">
  <app-utility-toolbar />
  <h1 class="header col-12">Unit Management</h1>
  <form class="w-100" [formGroup]="searchForm">
    <div class="row">
      <mat-form-field class="col-3">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" [placeholder]="'Name'" />
      </mat-form-field>
      <mat-form-field class="col-3">
        <mat-label>ID</mat-label>
        <input matInput formControlName="id" [placeholder]="'ID'" />
      </mat-form-field>
      <mat-form-field class="col-3">
        <mat-label>Type</mat-label>
        <input matInput [formControlName]="'type'" [placeholder]="'Type'" />
      </mat-form-field>
      <mat-form-field class="col-3">
        <mat-label>Parent Unit ID</mat-label>
        <input
          matInput
          formControlName="parentUnit"
          [placeholder]="'Parent Unit ID'"
        />
      </mat-form-field>
    </div>

    <div class="row">
      <div class="col-12 buttons mt-2 mb-3">
        <button
          mat-raised-button
          class="pull-right"
          type="submit"
          color="accent"
          [disabled]="searchDisabled"
          (click)="newSearch()"
        >
          Search
        </button>
        <button
          type="button"
          mat-raised-button
          class="pull-right me-2"
          (click)="clearSearch()"
        >
          Clear Search
        </button>
        @if (rights.includes('AddEditUnits')) {
          <button
            type="button"
            mat-button
            color="primary"
            (click)="openCreateUnitDialog()"
          >
            <mat-icon>add</mat-icon>Add New Unit
          </button>
        }
      </div>
    </div>
  </form>

  <kendo-grid
    #grid
    [kendoGridBinding]="gridData"
    [height]="700"
    [navigable]="true"
    (detailExpand)="detailExpand($event)"
  >
    <kendo-grid-column field="UnitId" title="Unit ID" />
    <kendo-grid-column field="UnitName" title="Unit Name" />
    <kendo-grid-column field="UnitType" title="Unit Type" />
    <kendo-grid-column field="ParentId" title="Parent ID" />
    <kendo-grid-column field="ParentName" title="Parent Unit Name" />

    <ng-template kendoGridNoRecordsTemplate>{{ noRecordMessage }}</ng-template>

    <ng-template let-dataItem let-rowIndex kendoGridDetailTemplate>
      @if (gridForm) {
        <section>
          <form [formGroup]="gridForm" (save)="saveUser($event)">
            <mat-form-field class="col-3">
              <mat-label>Unit ID</mat-label>
              <input
                matInput
                readonly
                [formControlName]="'unitID'"
                [placeholder]="'Unit ID'"
              />
            </mat-form-field>
            <mat-form-field class="col-3">
              <mat-label>Unit Name</mat-label>
              <input
                matInput
                [formControlName]="'unitName'"
                [placeholder]="'Unit Name'"
              />
            </mat-form-field>
            <mat-form-field class="col-3">
              <mat-label>Unit Type</mat-label>
              <input
                matInput
                [formControlName]="'unitType'"
                [placeholder]="'Unit Type'"
                [required]="required"
              />
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-form-field class="col-3">
              <mat-label>Parent Unit</mat-label>
              <mat-select
                [formControlName]="'parentUnit'"
                [placeholder]="'Parent Unit'"
                [required]="required"
              >
                @for (parent of unitDetails.AllowedParents; track parent.Name) {
                  <mat-option [value]="parent.ID">
                    {{ parent.Name }}
                  </mat-option>
                }
              </mat-select>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-form-field class="example-chip-list col-6">
              <mat-label>Roles</mat-label>
              <mat-chip-grid #roleList aria-label="Roles">
                @for (role of roles; track role.Name) {
                  <mat-chip-row
                    [selectable]="selectable"
                    [removable]="'true'"
                    (removed)="removeRole($event, role)"
                  >
                    {{ role.Name }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                }
                <input
                  #roleInput
                  placeholder="Select Role..."
                  [formControl]="roleCtrl"
                  [matAutocomplete]="autoRole"
                  [matChipInputFor]="roleList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="addItem($event, roles, roleCtrl)"
                  (click)="focusRoles()"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #autoRole="matAutocomplete"
                (optionSelected)="selectedRole($event)"
              >
                @for (role of filteredRoles | async; track role) {
                  <mat-option [value]="role">
                    {{ role }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <div class="col-12 mb-5">
              @if (rights.includes('AddEditUnits')) {
                <button
                  type="button"
                  mat-flat-button
                  class="pull-right"
                  color="accent"
                  [disabled]="loading"
                  (click)="saveUnit(dataItem)"
                >
                  Save
                </button>
              }
              <button
                type="button"
                mat-stroked-button
                color="warn"
                class="pull-right me-2"
                (click)="detailCollapse($event)"
              >
                Cancel
              </button>
              <button
                type="button"
                mat-button
                color="primary"
                class="pull-right me-2"
                (click)="downloadChangeHistory(dataItem)"
              >
                <mat-icon>download</mat-icon>Download Change History
              </button>
            </div>
            <div class="row">
              <div class="col-4">
                <h4>Owned Units</h4>
                <ul class="data-list">
                  @for (owned of unitDetails.ChildUnits; track owned.ID) {
                    <li> {{ owned.ID }} &mdash; {{ owned.Name }} </li>
                  }
                </ul>
              </div>
              <div class="col-4">
                <h4>Unit Managers</h4>
                <ul class="data-list">
                  @for (mgr of unitDetails.Managers; track mgr.ID) {
                    <li> {{ mgr.ID }} &mdash; {{ mgr.UserName }} </li>
                  }
                </ul>
              </div>
              <div class="col-4">
                <h4>Rep Codes</h4>
                <ul class="data-list">
                  @for (rep of unitDetails.Reps; track rep.RepCode) {
                    <li> {{ rep.RepCode }} &mdash; {{ rep.Name }} </li>
                  }
                </ul>
              </div>
            </div>
          </form>
        </section>
      }
    </ng-template>
  </kendo-grid>
</div>
<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: false }" />
